import { Directive, ElementRef, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { TogglePasswordComponent } from './toggle-password.component';
import { IonInput } from '@ionic/angular';

@Directive({
    selector: '[libPasswordInputToggle]ion-input',
    standalone: true,
})
export class PasswordInputToggleDirective implements OnInit {
    private readonly togglePassword = this.viewContainer.createComponent(TogglePasswordComponent);
    private readonly mutationObserver = new MutationObserver(() => {
        // Ensures we only append the child once.
        this.mutationObserver.disconnect();
        // If we try to append the child in ngOnInit,
        // it won't be the last child and won't tab correctly.
        const hostElement = this.viewContainer.element.nativeElement as HTMLElement;
        const togglePasswordElement = this.togglePassword.location.nativeElement as HTMLElement;
        this.renderer.appendChild(hostElement, togglePasswordElement);
    });

    public constructor(
        private readonly ionInput: IonInput,
        private readonly ionInputElement: ElementRef<HTMLIonInputElement>,
        private readonly viewContainer: ViewContainerRef,
        private readonly renderer: Renderer2,
    ) {
        this.fixPasswordInputs();
    }

    public ngOnInit() {
        this.mutationObserver.observe(this.ionInputElement.nativeElement, { childList: true });

        const passwordChanged = this.togglePassword.instance.showingPasswordChanged;
        passwordChanged.subscribe(this.setIonInputType);
    }

    private fixPasswordInputs() {
        const inputElement = this.ionInputElement.nativeElement;
        this.renderer.setStyle(inputElement, 'pointer-events', 'unset');
        this.ionInput.inputmode = 'text';
        this.ionInput.type = 'password';
    }

    private setIonInputType = (showingPassword: boolean) =>
        (this.ionInput.type = showingPassword ? 'text' : 'password');
}
